import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {candybarFetch, candybarItemFavAdd, candybarItemRemove, candybarItemSave, candybarItemSelect} from '../../../actions/creators/checkout/candybar';
import CandybarItem from "./CandybarItem";
import StepHeader from '../StepHeader';
import {CHECKOUT_CONTEXT_CANDYBAR, prevStep} from '../../../actions/creators/checkout';
import {candybarCategorySelect, candybarItemEditCancel} from '../../../actions/creators/checkout/candybar';
import CouponsCategorySelector from '../../user/coupons/CouponsCategorySelector';
import { getCandybarBlocks, getCandybarCatalog, getCandybarSelectedCategoryId, getCandybarSelectedCategoryItems, getCandybarSelectedItem, getCandybarSelectedUnit, getCheckoutContext, getCheckoutOrderCandybarItems, isUserLogged } from '../../../reducers';
import CatalogBlocks from '../../common/CatalogGrid/CatalogBlocks';
import CandybarGridItem from './CandybarGridItem';
import favesIcon from '../../../assets/img/candybar/faves-cat-icon.png';
import favesIconSelected from '../../../assets/img/candybar/faves-cat-icon-selected.png';
import WindowPanel from '../../common/WindowPanel';
import { AnalyticsCandybar } from '../../../utils/analytics';

const CandybarCatalog = styled.div`
  display: ${props => props.hidden ? 'none' : 'block'};
`;

const favoritesCategory = {
  id: 'faves',
  name: 'Favoritos',
  color: '#EE2C37',
  icon: favesIcon,
  icon_selected: favesIconSelected,
};
const favoritesBlock = {id: 'faves', name: 'Tus favoritos', emptyMessage: "Aún no tienes artículos agregados a favoritos."};
const myOrderBlock = {id: 0, name: 'Tu orden', emptyMessage: "Aún no tienes artículos agregados a tu orden."};

class CandybarSelection extends React.Component {
  constructor(props) {
    super(props);

    this.onBackClick = this.onBackClick.bind(this);
  }

  componentDidMount() {
    if (this.props.flowDirection === 'prev') {
      return;
    }

    if (!this.props.categories.length) {
      this.fetchCatalog();
    }

    const hasTickets = this.props.context !== CHECKOUT_CONTEXT_CANDYBAR;
    AnalyticsCandybar.trackSectionEntry(hasTickets);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.sessionId && this.props.sessionId !== prevProps.sessionId
      ||
      this.props.cinemaId && this.props.cinemaId !== prevProps.cinemaId
    ) {
      this.fetchCatalog();
    }
  }

  fetchCatalog() {
    const params = {};

    if (this.props.sessionId) {
      params.session_id = this.props.sessionId;
    } else if (this.props.cinemaId) {
      params.cinema_id = this.props.cinemaId;
    } else {
      return;
    }

    this.props.candybarFetch(params);
  }
  
  renderCatalog() {
    if (this.props.isLoading) {
      return '';
    } else if (this.props.loadError) {
      return 'Ocurrió un error.';
    } else if (!this.props.categories || !this.props.categories.length) {
      return '';
    }

    const categories = (
      this.props.isUserLogged
        ? [favoritesCategory]
        : []
    ).concat(this.props.categories);

    const blocks = 'faves' === this.props.selectedCategoryId
      ? [favoritesBlock]
      : this.props.blocks;

    return (
        <React.Fragment>
          <CouponsCategorySelector categories={categories} setCategory={this.props.onCategorySelect} category={this.props.selectedCategoryId}/>
          <CatalogBlocks
            blocks={[myOrderBlock]}
            items={this.props.order}
            actions={{onAdd: this.props.itemSelect, onRemove: this.props.onItemRemove}}
            RenderItem={CandybarGridItem}
          />
          <CatalogBlocks blocks={blocks} items={this.props.items} actions={{onAdd: this.props.itemSelect}} RenderItem={CandybarGridItem} />
        </React.Fragment>
    )
  }

  render() {
    return (
      <React.Fragment>
        <CandybarCatalog>
          <StepHeader onPrevClick={this.onBackClick} label="Dulcería" />
          {this.renderCatalog()}
        </CandybarCatalog>

        {this.props.selectedItem &&
          <WindowPanel
            desktopModal
            closeOnOutsideClick={false}
          >
            <CandybarItem
              item={this.props.selectedItem}
              unit={this.props.selectedUnit}
              onSave={this.props.onItemSubmit}
              onCancel={this.props.onItemEditCancel}
              onFavAdd={this.props.onItemFavAdd}
            />
          </WindowPanel>
        }
      </React.Fragment>
    )
  }

  onBackClick = () => {
    if (CHECKOUT_CONTEXT_CANDYBAR === this.props.context) {
      document.location = '/dulceria';
    } else {
      this.props.prevStep();
    }
  }
}

const mapStateToProps = state => {
  return {
    blocks: getCandybarBlocks(state),
    context: getCheckoutContext(state),
    isLoading: state.checkoutData.candybar.isLoading,
    isUserLogged: isUserLogged(state),
    loadError: state.checkoutData.candybar.loadError,
    order: getCheckoutOrderCandybarItems(state),
    categories: getCandybarCatalog(state),
    items: getCandybarSelectedCategoryItems(state),
    selectedCategoryId: getCandybarSelectedCategoryId(state),
    selectedItem: getCandybarSelectedItem(state),
    selectedUnit: getCandybarSelectedUnit(state),
    flowDirection: state.checkoutData.flowDirection,
  }
};

const mapDispatchToProps = dispatch => ({
  candybarFetch: params => dispatch(candybarFetch(params)),
  onCategorySelect: (categoryId) => dispatch(candybarCategorySelect(categoryId)),
  itemSelect: (itemId, unitId) => dispatch(candybarItemSelect(itemId, unitId)),
  onItemSubmit: (item, unitId, config) => dispatch(candybarItemSave(item, unitId, config)),
  onItemRemove: (itemId, unitId) => dispatch(candybarItemRemove(itemId, unitId)),
  onItemEditCancel: () => dispatch(candybarItemEditCancel()),
  onItemFavAdd: (itemId, add) => dispatch(candybarItemFavAdd(itemId, add)),
  prevStep: () => dispatch(prevStep()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CandybarSelection);